// Carousel and show/hide logic for cart gift popup
(function(){
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++){
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function debounce(fn, wait) { var t; return function(){ clearTimeout(t); t = setTimeout(fn, wait); }; }

  document.addEventListener('DOMContentLoaded', function(){
    var overlays = document.querySelectorAll('[id^="cart-gift-popup-overlay-"]');
    overlays.forEach(function(overlay){
      var id = overlay.id.replace('cart-gift-popup-overlay-','');
      var cookieName = 'cart_gift_popup_' + id;
      if (getCookie(cookieName) === 'hidden') return;

      // Show overlay with accessibility and focus management
      var previouslyFocused = document.activeElement;
      function openOverlay(){
        overlay.removeAttribute('hidden');
        // prevent background scroll
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        // focus close button for keyboard users
        var closeBtn = overlay.querySelector('.cart-gift-popup-close');
        if (closeBtn) closeBtn.focus();
        // add key listener for ESC
        document.addEventListener('keydown', escHandler);
      }

      function escHandler(e){ if (e.key === 'Escape' || e.key === 'Esc') { closeOverlay(); } }

      function closeOverlay(){
        // if "don't show again" is checked, persist cookie
        try{
          var dontShowEl = document.getElementById('cart-gift-popup-dont-show-' + id);
          if (dontShowEl && dontShowEl.checked) setCookie(cookieName,'hidden',30);
        } catch (err){}
        overlay.setAttribute('hidden','');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.removeEventListener('keydown', escHandler);
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
      }

      // Show overlay now
      openOverlay();

      // Close button
      var closeBtn = overlay.querySelector('.cart-gift-popup-close');
      if (closeBtn) closeBtn.addEventListener('click', closeOverlay);

      // clicking outside modal closes
      overlay.addEventListener('click', function(e){ if (e.target === overlay) closeOverlay(); });

      // Dont show again checkbox
      var dontShow = document.getElementById('cart-gift-popup-dont-show-' + id);
      if (dontShow) {
        dontShow.addEventListener('change', function(){
          if (this.checked) setCookie(cookieName,'hidden',30); else setCookie(cookieName,'',-1);
        });
      }

      // Carousel logic
      var carousel = overlay.querySelector('.cart-gift-carousel');
      if (!carousel) return;
      var viewport = carousel.querySelector('.cart-gift-carousel__viewport');
      var track = carousel.querySelector('.cart-gift-carousel__track');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('.cart-gift-carousel__slide'));
      var prev = carousel.querySelector('.cart-gift-carousel__arrow--prev');
      var next = carousel.querySelector('.cart-gift-carousel__arrow--next');
      var dotsContainer = carousel.querySelector('.cart-gift-carousel__dots');

  var state = { page: 0, visible: 3, slideWidth: 0, pageCount: 0 };

      // Use fixed slide width in pixels
      var FIXED_SLIDE_WIDTH = 180; // px per user request
      var GAP = 14; // must match CSS gap between slides

      function updateLayout(){
        // Force visible count to 3 regardless of viewport
        state.visible = 3;
        // set slide widths to fixed value
        state.slideWidth = FIXED_SLIDE_WIDTH;
        slides.forEach(function(s){ s.style.width = state.slideWidth + 'px'; });

        // compute page count based on fixed visible count
        state.pageCount = Math.max(1, Math.ceil(slides.length / state.visible));
        if (state.page > state.pageCount - 1) state.page = state.pageCount - 1;

  // compute total width of visible slides (including gaps)
  var totalVisibleWidth = state.visible * state.slideWidth + Math.max(0, state.visible - 1) * GAP;
  // make viewport exactly the width of visible slides and center it with margin:0 auto
  viewport.style.width = totalVisibleWidth + 'px';
  viewport.style.marginLeft = 'auto';
  viewport.style.marginRight = 'auto';
  // remove any padding on viewport and track so transform calculations are exact
  viewport.style.paddingLeft = '0px';
  viewport.style.paddingRight = '0px';
  track.style.paddingLeft = '0px';
  track.style.paddingRight = '0px';

        moveTo(state.page);
        buildDots();
        updateArrows();
      }

      function moveTo(pageIndex){
        state.page = Math.max(0, Math.min(pageIndex, state.pageCount - 1));
        var offsetSlides = state.page * state.visible;
        var effective = state.slideWidth + GAP;
        var x = -(offsetSlides * effective);
        track.style.transform = 'translateX(' + x + 'px)';
        updateDots();
        updateArrows();
      }

      function updateArrows(){
        if (prev) prev.disabled = state.page <= 0;
        if (next) next.disabled = state.page >= state.pageCount - 1;
      }

      function buildDots(){
        if (!dotsContainer) return;
        var pages = state.pageCount;
        if (dotsContainer.children.length === pages) return; // already built
        dotsContainer.innerHTML = '';
        for (var p=0;p<pages;p++){
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cart-gift-carousel__dot';
          (function(page){ dot.addEventListener('click', function(){ moveTo(page); }); })(p);
          dotsContainer.appendChild(dot);
        }
        updateDots();
      }

      function updateDots(){
        if (!dotsContainer) return;
        var dots = Array.prototype.slice.call(dotsContainer.children);
        dots.forEach(function(d,i){ d.classList.toggle('is-active', i === state.page); });
      }

      // Arrow handlers
  if (prev) prev.addEventListener('click', function(){ moveTo(state.page - 1); });
  if (next) next.addEventListener('click', function(){ moveTo(state.page + 1); });

      // Resize handling
      window.addEventListener('resize', debounce(updateLayout, 120));

      // Initialize
      updateLayout();

      // AJAX add-to-cart: intercept forms inside this overlay's carousel
      var addForms = overlay.querySelectorAll('.cart-gift-add-form');
      addForms.forEach(function(form){
        form.addEventListener('submit', function(e){
          e.preventDefault();
          var submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.dataset.origText = submitBtn.innerHTML;
            submitBtn.innerHTML = '...';
          }

          var action = form.getAttribute('action') || '/cart/add';
          var url = action.indexOf('.js') !== -1 ? action : action + '.js';
          var body = new URLSearchParams(new FormData(form));

          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body
          }).then(function(response){
            if (response.ok) {
              // success - reload current page to reflect cart changes
              window.location.reload();
            } else {
              return response.json().then(function(json){ throw json; });
            }
          }).catch(function(err){
            console.error('Add to cart failed', err);
            try { alert('添加到购物车失败，请稍后重试。'); } catch(e){}
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.innerHTML = submitBtn.dataset.origText || 'Hinzufügen';
            }
          });
        });
      });
    });
  });
})();
